
import React from 'react'
import { MS_IN_A_DAY } from '../../../../constants/constants'
import { renderLevel } from '../../../../utils/alertUtils'
import { productConfig } from '../../../../config/config-service'
import CarePlanItem from '../CarePlanItem'
import { CAREPLAN_VALUE_TYPES } from '../../../../constants/carePlanValueTypes'

export default class BloodPressureRangeItem extends CarePlanItem {
  constructor (props) {
    super(props)
    this.type = 'bp_range'
  }

  rangeSystolicMinInputElement () {
    return this.getInputElement(
      40, 110, 5,
      CAREPLAN_VALUE_TYPES.SYSTOLIC_MIN.get(val => val),
      CAREPLAN_VALUE_TYPES.SYSTOLIC_MIN.set(val => val)
    )
  }

  rangeSystolicMaxInputElement () {
    return this.getInputElement(
      115, 200, 5,
      CAREPLAN_VALUE_TYPES.SYSTOLIC_MAX.get(val => val),
      CAREPLAN_VALUE_TYPES.SYSTOLIC_MAX.set(val => val)
    )
  }

  rangeDiastolicMinInputElement () {
    return this.getInputElement(
      40, 70, 5,
      CAREPLAN_VALUE_TYPES.DIASTOLIC_MIN.get(val => val),
      CAREPLAN_VALUE_TYPES.DIASTOLIC_MIN.set(val => val)
    )
  }

  rangeDiastolicMaxInputElement () {
    return this.getInputElement(
      75, 140, 5,
      CAREPLAN_VALUE_TYPES.DIASTOLIC_MAX.get(val => val),
      CAREPLAN_VALUE_TYPES.DIASTOLIC_MAX.set(val => val)
    )
  }

  rangeHeartRateMinInputElement () {
    return this.getInputElement(
      30, 70, 5,
      CAREPLAN_VALUE_TYPES.HEART_RATE_MIN.get(val => val),
      CAREPLAN_VALUE_TYPES.HEART_RATE_MIN.set(val => val)
    )
  }

  rangeHeartRateMaxInputElement () {
    return this.getInputElement(
      75, 170, 5,
      CAREPLAN_VALUE_TYPES.HEART_RATE_MAX.get(val => val),
      CAREPLAN_VALUE_TYPES.HEART_RATE_MAX.set(val => val)
    )
  }

  getTimeInput () {
    return this.getInputElement(
      1, 14, 1,
      CAREPLAN_VALUE_TYPES.TIME.get(val => val / MS_IN_A_DAY),
      CAREPLAN_VALUE_TYPES.TIME.set(val => val * MS_IN_A_DAY)
    )
  }

  minCountIsPlural () {
    return CAREPLAN_VALUE_TYPES.MIN_COUNT.get(val => val)(this.state.itemData) > 1
  }

  minCountInputElement () {
    return this.getInputElement(
      1, 5, 1,
      CAREPLAN_VALUE_TYPES.MIN_COUNT.get(val => val),
      CAREPLAN_VALUE_TYPES.MIN_COUNT.set(val => val)
    )
  }

  renderGoal () {
    return <div>Keep BP and HR in range</div>
  }

  renderClinicianTrigger () {
    const getNumDays = CAREPLAN_VALUE_TYPES.TIME.get(val => val / MS_IN_A_DAY)
    const numDays = this.getValue(getNumDays)
    const hasMinThreshold = this.hasTrigger('min_count')

    return (
      <div>If systolic BP is below {this.rangeSystolicMinInputElement()} or above {this.rangeSystolicMaxInputElement()} mmHg,
        {productConfig().carePlan.hasDiastolicThreshold &&
          <span>
            <br />diastolic BP is below {this.rangeDiastolicMinInputElement()} or above {this.rangeDiastolicMaxInputElement()} mmHg,
          </span>}
        <br />or heart rate is below {this.rangeHeartRateMinInputElement()} or above {this.rangeHeartRateMaxInputElement()} bpm{!hasMinThreshold ? '.' : ','}
        {hasMinThreshold && (
          <span>
            <br />for {this.minCountInputElement()} {this.minCountIsPlural() ? <span>consecutive readings within  {this.getTimeInput()} day{numDays === 1 ? '' : 's'}.</span> : <span>reading.</span>}
          </span>)}
      </div>
    )
  }

  renderCondensed () {
    const level = this.state.itemData.level ? renderLevel(this.state.itemData.level, true) : ''
    return (
      <div>{level} BP &lt; {this.getValueElement(CAREPLAN_VALUE_TYPES.SYSTOLIC_MIN.get(val => val))}/{this.getValueElement(CAREPLAN_VALUE_TYPES.DIASTOLIC_MIN.get(val => val))} or
        &gt; {this.getValueElement(CAREPLAN_VALUE_TYPES.SYSTOLIC_MAX.get(val => val))}/{this.getValueElement(CAREPLAN_VALUE_TYPES.DIASTOLIC_MAX.get(val => val))}
        <br />Heart rate &lt; {this.getValueElement(CAREPLAN_VALUE_TYPES.HEART_RATE_MIN.get(val => val))} or &gt; {this.getValueElement(CAREPLAN_VALUE_TYPES.HEART_RATE_MAX.get(val => val))} bpm
      </div>
    )
  }
}
